define('CustomDisplayStock.Facets.ItemCell.View', [
    'Facets.ItemCell.View',
    'underscore',
    'Profile.Model'
], function CustomDisplayStockFacetsItemCellView(
    FacetsItemCellView,
    _,
    ProfileModel
) {
    'use strict';

    _.extend(FacetsItemCellView.prototype, {
        getContext: _.wrap(FacetsItemCellView.prototype.getContext, function getContextWrap(fn) {
            var originalRet = fn.apply(this, _.toArray(arguments).slice(1));
            var isLoggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
            originalRet.displaystock = this.model.get('custitem_show_ability_stock') && isLoggedIn;
            originalRet.model = this.model;
            return originalRet;
        })
    });
});
